// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_loginFormButtonGroup__OI3te {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
@media screen and (max-width: 769px) {
  .style_loginFormButtonGroup__OI3te {
    display: block;
    text-align: center;
  }
}

@media screen and (max-width: 769px) {
  .style_loginFormlink__J8ePt {
    text-align: center;
    margin-top: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Authentication/login/style.module.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAUF;AATE;EAJF;IAKI,cAAA;IACA,kBAAA;EAYF;AACF;;AATE;EADF;IAEI,kBAAA;IACA,gBAAA;EAaF;AACF","sourcesContent":["@import \"style/custom.scss\";\n\n.loginFormButtonGroup {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  @media screen and (max-width: 769px) {\n    display: block;\n    text-align: center;\n  }\n}\n.loginFormlink {\n  @media screen and (max-width: 769px) {\n    text-align: center;\n    margin-top: 10px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primaryColor": `#16b3d5`,
	"successColor": `#4caf50`,
	"errorColor": `#f44336`,
	"primaryFont": `"Nunito", sans-serif`,
	"activeColor": `#6b778c`,
	"textPrimaryColor": `#0f265c`,
	"textSecColor": `#909090`,
	"warningColor": `#ff9800`,
	"loginFormButtonGroup": `style_loginFormButtonGroup__OI3te`,
	"loginFormlink": `style_loginFormlink__J8ePt`
};
export default ___CSS_LOADER_EXPORT___;
